<div>
  <div class="dx-fieldset" [ngStyle]="{ margin: '20px 30px' }">
    <div class="dx-field" *ngIf="exportParameter.version != 'INTERSHOP'">
      <div class="dx-field-label">{{ 'Medien exportieren' | translate }}</div>
      <div class="dx-field-value">
        <span style="display: inline-flex; float: inline-end; align-items: center">
          <dx-switch [(value)]="exportParameter.includeMime" [readOnly]="isOnboarding"></dx-switch>
          <np-license-upgrade-button *ngIf="isOnboarding"
                                     style="margin-left: 5px"
                                     infoText="Das tut uns Leid.
        Diese Funktion steht in der freien Onboarding-Version nicht zur Verfügung. Möchten Sie diese nutzen, kontaktieren Sie gerne unseren Vertrieb."></np-license-upgrade-button>
        </span>
      </div>
    </div>
    <div class="dx-field" *ngIf="!exportParameter.includeMime">
      <div class="dx-field-label">{{ 'Medien als Url verwenden' | translate }}</div>
      <div class="dx-field-value">
        <span style="display: inline-flex; float: inline-end; align-items: center">
          <dx-switch [(value)]="exportParameter.useMediaUrl" [readOnly]="isOnboarding" [disabled]="isScireum"></dx-switch>
          <np-license-upgrade-button *ngIf="isOnboarding"
                                     style="margin-left: 5px"
                                     infoText="Das tut uns Leid.
        Diese Funktion steht in der freien Onboarding-Version nicht zur Verfügung. Möchten Sie diese nutzen, kontaktieren Sie gerne unseren Vertrieb."></np-license-upgrade-button>
        </span>
      </div>
    </div>

    <div class="dx-field" *ngIf="exportParameter.includeMime">
      <div class="dx-fieldset">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Original verwenden' | translate }}</div>
          <div class="dx-field-value">
            <dx-switch [(value)]="exportParameter.orignialSize"></dx-switch>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Quadratische Ansicht' | translate }}</div>
          <div class="dx-field-value {{
              exportParameter.imageSquared ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder'
            }}">
            <dx-switch [(value)]="exportParameter.imageSquared"></dx-switch>
          </div>
        </div>
        <div class="dx-field" *ngIf="exportParameter.imageSquared">
          <div class="dx-field-label">{{ 'Hintergrundfarbe wählen' | translate }}</div>
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
            <label class="placeLabel {{ exportParameter.imageBgColor ? 'placeLabelSmall' : '' }}">
              BACKGROUND COLOR
            </label>
            <dx-color-box [(value)]="exportParameter.imageBgColor"></dx-color-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Maximale Größe (mb) (0 = kein Maximum)' | translate }}</div>
          <div class="dx-field-value">
            <dx-number-box [min]="0"
                           [max]="100000000"
                           [(value)]="exportParameter.maxMediaSize"
                           [showClearButton]="true"></dx-number-box>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!exportParameter.orignialSize">
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Maximale Seitenlänge' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
          <label class="placeLabel {{ maxResolution > 0 ? 'placeLabelSmall' : '' }}">MAX RESOLUTION</label>
          <dx-number-box [min]="16"
                         [max]="8192"
                         [(value)]="exportParameter.maxResolution"
                         [showClearButton]="true"></dx-number-box>
        </div>
      </div>

      <div class="dx-field">
        <div class="dx-field-label">{{ 'Dateityp' | translate }}</div>
        <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
          <label class="placeLabel {{ imageType?.length > 0 ? 'placeLabelSmall' : '' }}">FILE TYPE</label>
          <dx-select-box [(value)]="exportParameter.imageType"
                         [items]="imageTypes"
                         [searchEnabled]="true"
                         placeholder=""></dx-select-box>
        </div>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Rechtliche Zusatzinformationen exportieren' | translate }}</div>
      <div class="dx-field-value">
        <dx-switch [(value)]="exportParameter.includeLegal"></dx-switch>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Gefahrstoffklassen an Beschreibung anhängen' | translate }}</div>
      <div class="dx-field-value">
        <dx-switch [(value)]="exportParameter.includeHazmatClassesInDescription"></dx-switch>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Markennamen anstelle des Herstellernamens ausgeben' | translate }}</div>
      <div class="dx-field-value">
        <dx-switch id="exportBrandNameInsteadOfManufactureName" [(value)]="exportParameter.exportBrandNameInsteadOfManufactureName"></dx-switch>
      </div>
      <dx-tooltip target="#exportBrandNameInsteadOfManufactureName" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
        <div *dxTemplate="let data = data; of: 'content'">
          <div *ngIf="exportParameter.exportBrandNameInsteadOfManufactureName">
            {{ 'Herstellername im Export wird durch den zugeordneten Markenname ersetzt.' | translate }}
          </div>
          <div *ngIf="!exportParameter.exportBrandNameInsteadOfManufactureName">
            {{ 'Herstellername bleibt unverändert; Markenname wird zusätzlich als UDX-Feld exportiert' | translate }}
          </div>
        </div>
      </dx-tooltip>
    </div>

    <div *ngIf="showExportBrandNameAsTechnicalFeature" class="dx-field">
      <div class="dx-field-label">{{ 'Markennamen als technisches Merkmal exportieren' | translate }}</div>
      <div class="dx-field-value">
        <dx-switch [(value)]="exportParameter.exportBrandNameAsTechnicalFeature"></dx-switch>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Alternative Description Short verwenden' | translate }}
        <div *ngIf="exportParameter.useAlternativeWawiDescriptionShort">
          <dx-select-box [dataSource]="wawiFields"
                         [(value)]="exportParameter.usedStringAlternativeWawiDescriptionShort"
                         [searchEnabled]="true"
                         placeholder="Feld auswählen..."></dx-select-box>

        </div>


      </div>
      <div class="dx-field-value">
        <dx-switch [(value)]="exportParameter.useAlternativeWawiDescriptionShort"></dx-switch>
      </div>
    </div>

  </div>
</div>
